import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { BookmarkButton } from 'src/components/Bookmarks';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { Breadcrumb } from 'src/components/ProgramDetails/BreadcrumbBar/Breadcrumb';
import { useLimitedCatalog } from '@src/hooks/useLimitedCatalog';
import styles from './BreadcrumbBar.module.scss';
interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const BreadcrumbBar: React.FC<Props> = ({ program, loading }) => {
	const isMobile = useIsMobile();
	const { limitedCatalogEnabled } = useLimitedCatalog();

	if (!loading && (!program?.name || !program?.id)) {
		return null;
	}

	return (
		<Skeleton dataLoading={loading}>
			<div className={styles.breadcrumbBar}>
				<Breadcrumb currentPage={program?.name} />
				{!limitedCatalogEnabled && (
					<BookmarkButton
						apName={program?.studentFacingAcademicPartner.name}
						hitName={program?.name}
						offeringId={program?.id}
						theme='light'
						variant={isMobile ? 'iconOnly' : 'button'}
					/>
				)}
			</div>
		</Skeleton>
	);
};
